let baseState = () => {
  return {
    permissions: [],
    myPermissions: {}
  }
}

const state = baseState()

export default state
export { baseState }
